<template>
  <v-dialog
      v-model="value"
      persistent
      :max-width="maxWidth"
      >
      <v-card
               
      >
          <v-card-title
            class="text-h5"
          >
            Copy Day: {{dateTitle}}
          </v-card-title>

          <v-card-text
            style="min-height: 500px;"
          >
       
            <v-container
              class="pa-0 ma-0 " 
              style="height: 500px; overflow-y: auto;"               
            >        

                <v-row
                  class="pa-0 ma-0"
                >
                  <v-col cols="6"
                    class="pa-0 ma-0"
                  >
                    <h5>
                      Shifts
                    </h5>
                    <v-row
                      class="ma-0 pa-0"
                      align="center"
                      v-for="(assignment,i) in items"
                      :key="`copy_assignment_${assignment.shift_id}`"
                      :stylex="`${assignment.odd ? 'background-color: red':''}`"
                      :style="i < items.length - 1 ? 'border-bottom: 1px black solid':''"
                    >
                      <v-col cols="6"
                          class="pa-0 ma-0"
                      >
                          <v-checkbox
                            v-model="selectedShifts[assignment.shift_id]"
                            hide-details
                            dense
                            :ripple="false"
                            :label="assignment.shift_name"
                          ></v-checkbox>

                        
                      </v-col>
                      <v-col cols="6"
                          class="pa-0 ma-0"
                      >                        
                        <checkbox-list
                          :items="assignment.provider_users"
                          v-model="selectedUsers[assignment.shift_id]"
                          label=""
                          width="100%"
                          :chips="false"
                          :outlined="false"
                          v-if="assignment.provider_users.length > 1"
                          :disabled="!selectedShifts[assignment.shift_id]"
                        />  
                        <div
                          style="padding-left: 23px;"
                          v-else
                          v-html="assignment.provider_users[0].html"
                        />
                      </v-col>

                    </v-row>


                  </v-col>
                  <v-col cols="1"
                    class="pa-0 ma-0"
                  >
                  &nbsp;
                  </v-col>
                  <v-col cols="5"
                    class="pa-0 ma-0"
                  >
                    <v-row
                      class="pa-0 ma-0"
                    >
                      <v-col
                        class="pa-0 ma-0"
                        cols="12"
                      >
                        <h5>
                          Target
                        </h5>
                        <v-date-picker
                          v-model="targetDates"
                          multiple
                          no-title
                          :allowed-dates="isAllowed"
                        ></v-date-picker>      
                      </v-col>
                    </v-row>
                    <v-row
                      class="pa-0 ma-0"
                    >
                      <v-col
                        class="pa-0 ma-0"
                        cols="12"
                      >
                     
                        <v-chip
                          v-for="copyDate in copyDates"
                          color="#82B1FF"
                          :key="`copydate_${copyDate.date}`"
                        >
                          {{copyDate.dateFormatted}}
                        </v-chip>

                        <div
                          v-html="copyDateErrors"
                        />


<!--
    <v-list three-line>
      <template v-for="copyDate in copyDates">

        <v-list-item
          :key="`copydate_${copyDate.date}`"
        >
          <v-list-item-content>
            <v-list-item-title :text="copyDate.dateFormatted"></v-list-item-title>
            <v-list-item-subtitle :text="copyDate.date"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
-->
                      </v-col>
                    </v-row>
                  </v-col>


                </v-row>

            </v-container>
      
          </v-card-text>
          <v-card-actions>
          

            <v-spacer></v-spacer>
              <v-btn
                @click="save()"
                :disabled="!allAssignments || !allAssignments.length"
                width="80"
              >
                Copy
              </v-btn>              


              <v-btn
                @click="cancel()"
                width="80"
              >
                Cancel
              </v-btn>              

          </v-card-actions>          
      </v-card>

  </v-dialog>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import checkboxList from '@/components/checkbox-list'
import {formatSimple} from '@/methods/formatters';

  export default {
    props: {
      value: {
        default: false,
        type: Boolean
      },
      'max-width': {
        default: '1000',
        type: String
      },
      shifts: {
          type: Array,
          default: () => []
      }, 
      assignments: {
          type: Object,
          default: () => {}
      },       
      title: {
        default: 'Copy Day',
        type: String
      },
      group_id: {
          type: String,
          default: ''
      },     
      date: {
          type: String,
          default: ''
      },  
      providers: {
          type: Array,
          default: () => []
      },                                  
    },
    components: {
      'checkbox-list': checkboxList,
    },    
    data: () => ({
      targetDates: [],
      selectedShifts: {},
      selectedUsers: {},      
    }),
    mounted() {
      this.defaultSelectedShifts()
    },
    methods: {
      isAllowed(dt) {
        console.log('isAllowed', dt)
        return dt !== this.date
      },
      dateFromString (dt) {
        if (!dt) {
          return null
        }
        let pieces = dt.split('-')
        let date = new Date(pieces[0],parseInt(pieces[1])-1, pieces[2])
        return date
      },
      defaultSelectedShifts () {

        for (let id in this.assignments) {

          let assignment = this.assignments[id]
          this.$set(this.selectedShifts,assignment.shift.id,true)

          let users = []
          if (assignment.users && assignment.users.length) {
            assignment.users.map(id => {
              users.push(id)
            })
          }
          this.$set(this.selectedUsers,assignment.shift.id,users)
        }

      },
      isSelected(item) {
        if (!this.selectedShifts[item.shift_id]) {
          return false
        }

        if (item.provider_users.length > 1) {
          let selectedUsers = this.selectedUsers[item.shift_id]

          return selectedUsers.length ? true : false
        }

        return true
      },
      save () {

        let params = {
          assignments: this.allAssignments
        }
        this.$emit('save', params)
      },
      cancel () {

        this.$emit('cancel')
      }
    },
    computed: {
      ...mapGetters(
          'schedule',['getColors',]
      ), 
      dateTitle () {
        let dt = this.dateFromString(this.date)

        return formatSimple(dt,'EEEE, MMMM d yyyy')
      },
      weekdayMap () {
        let map = {}

        this.shifts.map(s => {
          if (!s.personal) {

            let weekdayMap = {}
            let weekdays = s.weekdays
            if (!weekdays || !weekdays.length) {
              weekdays = ["0","1","2","3","4","5","6"]
            }

            weekdays.map(w => {
              weekdayMap[w+''] = true
            })
            map[s.id] = weekdayMap
          }
        })

        return map

      },
      copyDateErrors () {
        let errorHtml = ''
        this.copyDates.map(d => {
          if (d.error) {

            errorHtml += `<div class="warning--text">${d.error} for ${d.dateFormatted}</div>`
          }
        })
        return errorHtml
      },
      allAssignments () {
        let arr = []
        let cd = this.copyDates
        cd.map(c => {
          if (c.assignments && c.assignments.length) {
            arr.push(...c.assignments)
          }
        })        

        return arr
      },
      copyDates () {
        let arr = []
        let wem = this.weekdayMap
        let items = this.items
        this.targetDates.map(dt => {

          let date = this.dateFromString(dt)
          let dow = date.getDay()

          let shiftErrors = []
          let shiftAssignments = []
          items.map(s => {
            console.log('s', s)
            if (this.isSelected(s)) {

              let weekdays = wem[s.shift_id]
              if (!weekdays[dow+'']) {

                shiftErrors.push(s.shift_name)

              } else {
                let users = this.selectedUsers[s.shift_id]

                users.map(u => {

                  shiftAssignments.push({
                    shift_id: s.shift_id,
                    user_id: u,
                    date: dt
                  })

                })
              }
            }
          })

          arr.push({
            date: dt,
            dateFormatted: formatSimple(date,'EEEE, MMMM d'),
            error: shiftErrors.length ? `Warning, ${shiftErrors.join(', ')} is not available`: null,
            assignments: shiftAssignments
          })
        })
        return arr
      },
      providerMap () {

        let ret = {} 
        if (this.providers && this.providers.length) {
          this.providers.map(p => {
            ret[p.id] = p
          })
        }
        return ret
      },      
      items () {
        let arr = []

        let j = 0
        for (let id in this.assignments) {
          let assign = this.assignments[id]
          let provider_users = []
          assign.users.map(uid => {
            let provider = this.providerMap[uid]
            if (provider) {
              let c = this.getColors[provider.user_index]

              let fg = c[1]
              let bg = c[0]

              provider_users.push({
                shift_id: id,
                id: uid,
                name: `${provider.first_name} ${provider.last_name}`,
                html: `<div style="background-color: ${bg};color: ${fg};">${provider.first_name} ${provider.last_name}</div>`,//`<div style="background-color: ${bg};color: ${fg};>${provider.first_name} ${provider.last_name}</div>`
              })
            }
          })
          let odd = false
          if (++j % 2) {
            odd = true
          }

          arr.push({
            shift_id: assign.shift.id,
            shift_name: assign.shift.name, 
            provider_users,
            odd
          })
        }

        return arr
      }
    },
    watch: {
      value (newValue, oldValue) {

        if (newValue) {
          this.targetDates = []
          this.defaultSelectedShifts()
        }
      },
    }
  }
</script>

